import DOMPurify from "dompurify";

export function RenderRichText(props) {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.html) }}
    ></div>
  );
}
